import React, { useState } from "react";
import FusePageCarded from '@fuse/core/FusePageCarded';
import { makeStyles } from '@material-ui/core/styles';
import FuseLoading from '@fuse/core/FuseLoading';
import withReducer from 'app/store/withReducer';
import reducer from '../store';
import ListView from "./listView";

const useStyles = makeStyles({
	layoutRoot: {
		background: '#fcfcfc'
	},
	pullRight: {
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "flex-end"
	},
	buttonContainer: {
		display: 'flex',
		flexDirection: 'row'
	},
	buttonSquare: {
		borderRadius: '5px'
	},
	topBg: {
		background: '#fcfcfc'
	},
	contentCard: {
		marginBottom: "15px",
		borderRadius: "5px"
	}
});

function CardedFullWidth2TabbedSample() {
	const classes = useStyles();
	const [loading, setLoading] = useState(false);

	if (loading) {
		return (<FuseLoading />)
	}
	return (<>
		<FusePageCarded
			classes={{
				root: classes.layoutRoot,
				toolbar: 'p-0',
				topBg: classes.topBg,
				contentCard: classes.contentCard
			}}
			content={
				<>
					<div>
						{
							loading && <FuseLoading />
						}
						{
							!loading && <div className="w-full flex flex-col">
								<ListView />
								<div className="p-10" />
							</div>
						}
					</div>
				</>
			}
			innerScroll
		/>
	</>)
}

export default withReducer('incidentApp', reducer)(CardedFullWidth2TabbedSample);
